import images from "../../assets/images/Constant";
import homeData from "../../data/home.json";
import { GoArrowUpRight } from "react-icons/go";
import { Link } from "react-router-dom";

export default function ServicesSection() {

  const { servicesCTA } = homeData;

  return (
    <section className=" bg-white">

      {/* CTA SECTION */}
      <div className="bg-[#063B44]">

        <div className="flex flex-col lg:flex-row items-stretch">

          {/* LEFT IMAGE */}
          <div className="relative flex justify-center lg:justify-start shrink-0">

            <img
              src={images.service}
              alt=""
              className="w-full max-w-[500px] h-[220px] sm:h-[280px] lg:h-[300px] object-cover"
            />

            {/* ICON */}
            <div className="hidden lg:block absolute top-1/2 right-[-80px] -translate-x-1/2 -translate-y-1/2">

              <img
                src={images.serviceicon}
                alt=""
                className="w-16 md:w-20"
              />

            </div>

          </div>

          {/* RIGHT TEXT */}
          <div className="text-white px-6 sm:px-10 lg:px-20 py-8 lg:py-10 flex flex-col lg:flex-row items-start lg:items-center lg:justify-between gap-6 min-w-0">

            <div>
              <h3 className="text-2xl md:text-[45px] font-semibold leading-tight">
                {servicesCTA?.title}
              </h3>

              <p className="mt-4 text-sm md:text-base max-w-[576px]">
                {servicesCTA?.description}
              </p>
            </div>

            <Link to="/contact" className="bg-[#70D3F2] text-dark px-6 py-3 flex items-center gap-2 rounded-md whitespace-nowrap">
              {servicesCTA?.button}
              <GoArrowUpRight />
            </Link>

          </div>

        </div>

      </div>
    </section>
  );
}